export default [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/account/Profile'),
    children: [
      {
        path: 'GlobalSettings',
        name: 'GlobalSettings',
        component: () => import('@/components/account/GlobalSettings'),
        meta: { title: 'GlobalSettings' },
      },

      {
        path: '',
        alias: 'personal-information',
        name: 'personal-information',
        component: () => import('@/components/account/PersonalInformation'),
        meta: { title: 'Personal Information' },
      },
      {
        path: 'change-password',
        name: 'change-password',
        component: () => import('@/components/account/UpdatePassword'),
        meta: { title: 'Change Password' },
      },
      {
        path: 'remove-workspace',
        name: 'remove-workspace',
        component: () => import('@/components/account/RemoveWorkspace.vue'),
        meta: { title: 'Remove Workspace' },
      },
      {
        path: 'theme-setup',
        name: 'theme-setup',
        component: () => import('@/components/themeSetup/ThemeSetup.vue'),
        meta: { title: 'Theme Setup' },
      },
      {
        path: 'two-step-verification',
        name: 'two-step-verification',
        component: () => import('@/components/account/TwoStepVerification'),
        meta: { title: 'Two-Step Verification' },
      },
      {
        path: 'manage-permissions',
        name: 'manage-permissions',
        component: () => import('@/components/account/Permissions'),
        meta: { title: 'Manage Permissions' },
      },
      {
        path: 'signature',
        name: 'signature',
        component: () => import('@/components/account/Signature'),
        meta: { title: 'Signature' },
      },
      {
        path: 'initial',
        name: 'initial',
        component: () => import('@/components/account/Initial'),
        meta: { title: 'Initial' },
      },
      {
        path: 'subscription',
        name: 'subscription',
        component: () => import('@/components/account/Subscriptions.vue'),
        meta: { title: 'Subscription' },
      },
      {
        path: 'companyUsers',
        name: 'companyUsers',
        component: () => import('@/components/account/CompanyUsers'),
        meta: { title: 'Company Users' },
      },
      {
        path: 'companyProfile',
        name: 'companyProfile',
        component: () => import('@/components/account/Branding'),
        meta: { title: 'Company Profile' },
      },

      {
        path: 'paymentIntegration',
        name: 'pay-integrations',
        component: () => import('@/components/Configuration/Payment/PaymentIntegrations.vue'),
        meta: {
          title: 'Subscription',
        },
      },

      {
        path: 'paymentsCards',
        name: 'integrations',
        component: () => import('@/components/Configuration/Payment/Payment.vue'),
        meta: {
          title: 'Subscription payment',
        },
      },
      {
        path: 'export-or-import-application',
        name: 'export-or-import-application',
        component: () => import('@/components/account/ExportOrImportApplication'),
        meta: { title: 'Export or Import Application' },
      },
    ],
  },

  {
    path: '/profilesettings',
    name: 'profilesettings',
    component: () => import('@/views/account/Profilesettings'),
    children: [
      {
        path: '',
        alias: 'dashboard-settings',
        name: 'statistics',
        component: () => import('@/components/account/dashboardStats'),
        meta: { title: 'Dashboard Status' },
      },
      {
        path: 'document-expiration-reminders',
        name: 'expiration-reminders',
        component: () => import('@/components/account/DocumentExpirationReminders'),
        meta: { title: 'Document Expiration & Reminders' },
      },
      {
        path: 'application-settings',
        name: 'application-settings',
        component: () => import('@/components/account/ApplicationSettings'),
        meta: { title: 'Settings' },
      },
      {
        path: 'document-notifications',
        name: 'document-notifications',
        component: () => import('@/components/account/Notifications'),
        meta: { title: 'Notifications' },
      },
      {
        path: 'initial',
        name: 'profilesettings-initial',
        component: () => import('@/components/account/Initial'),
        meta: { title: 'Profile settings Initial' },
      },
      {
        path: 'myapps-credentials',
        name: 'myapps-credentials',
        component: () => import('@/components/account/AppCredentials'),
        meta: { title: 'My Apps Credentials' },
      },
      {
        path: 'global-filters',
        name: 'global-filters',
        component: () => import('@/components/account/GlobalFilters'),
        meta: { title: 'Global Filters' },
      },
      {
        path: 'transferAccount',
        name: 'AppOwnerTransfer',
        component: () => import('@/components/account/TransferOwnerShip'),
        meta: { title: 'Transfer Owner Ship' },
      },
      {
        path: 'ai-settings',
        name: 'AISettings',
        component: () => import('@/components/account/AISettings'),
        meta: { title: 'AISettings' },
      },
      {
        path: 'transferAccount/:requestId',
        name: 'AppOwnerTransferOTPAuth',
        component: () => import('@/components/account/TransferOTPAuth'),
        meta: { title: 'Transfer Owner Ship Authentication' },
      },
      {
        path: 'app-mode',
        name: 'app-mode-configuration',
        component: () => import('@/components/account/AppModeConfiguration'),
        meta: { title: 'Configure / Change Modes' },
      },
    ],
  },

  {
    path: '/branding',
    name: 'branding',
    component: () => import('@/views/account/Branding'),
    meta: { title: 'Branding' },
  },
];
